import { render, staticRenderFns } from "./CopyInputIcon.vue?vue&type=template&id=98e2d3ea&"
import script from "./CopyInputIcon.vue?vue&type=script&lang=js&"
export * from "./CopyInputIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports